import * as tslib_1 from "tslib";
import { OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import * as _ from "lodash";
import { Subscription } from "rxjs";
import { Alert } from "src/app/shared/class/Alert";
import { PlnTableComponent, } from "src/app/shared/components/pln-table/pln-table.component";
import { globalConst } from "src/app/shared/helpers/constants";
import { Helper } from "src/app/shared/helpers/helper";
import { Agent } from "src/app/shared/models/agent.model";
export class ServiceRequestComponent {
    constructor(spinner, serviceRequestService, authService, updateDatabaseService, router) {
        this.spinner = spinner;
        this.serviceRequestService = serviceRequestService;
        this.authService = authService;
        this.updateDatabaseService = updateDatabaseService;
        this.router = router;
        this.goback = "";
        this.expandedFilterPanel = true;
        this.subscription = new Subscription();
        this.companyOptions = [];
        this.regionalOptions = [];
        this.serviceLocalOptions = [];
        this.agents = [];
        this.lastUpdateTable = "";
        this.displayedColumns = [
            {
                value: "id",
                showValue: "ID",
                orderBy: false,
                size: 10,
            },
            {
                value: "situation",
                showValue: "Situação",
                orderBy: true,
                size: 10,
                type: PlnTableComponent.fieldValue().requestStatus,
            },
            {
                value: "date",
                showValue: "Data",
                orderBy: true,
                size: 8,
                type: PlnTableComponent.fieldValue().date,
            },
            {
                value: "hour",
                showValue: "Hora",
                orderBy: true,
                size: 7,
            },
            {
                value: "companyDescription",
                showValue: "Cliente",
                orderBy: true,
                size: 10,
            },
            {
                value: "regionalDescription",
                showValue: "Regional",
                orderBy: true,
                size: 15,
            },
            {
                value: "serviceLocalDescription",
                showValue: "Local",
                orderBy: true,
                size: 25,
            },
            {
                value: "agentName",
                showValue: "Técnico",
                orderBy: true,
                size: 10,
            },
        ];
        this.tableActions = [
            {
                action: "edit",
                icon: "edit",
                routerLink: "/serviceRequest/details",
                tooltip: "Editar",
            },
        ];
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.spinner.show();
            this.filtersForm = new FormGroup({
                id: new FormControl(null),
                status: new FormControl(""),
                company: new FormControl(null),
                regional: new FormControl(null),
                serviceLocal: new FormControl(null),
                agent: new FormControl(null),
            });
            yield this.loadCompanyOptions();
            yield this.loadRegionalOptions();
            yield this.loadServiceLocalOptions();
            yield this.loadAgents();
            this.spinner.hide();
            this.listenChangeCompany();
            this.listenChangeRegional();
            this.listenChangeServiceLocal();
            this.filter();
        });
    }
    listenChangeCompany() {
        const control = this.filtersForm.controls.company;
        control.valueChanges.subscribe(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!control.errors) {
                try {
                    if (control.value === "") {
                        yield this.loadRegionalOptions();
                        yield this.loadServiceLocalOptions();
                    }
                    else {
                        this.spinner.show();
                        this.regionalOptions = [];
                        this.filtersForm.controls.regional.setValue(null);
                        yield this.loadRegionalOptions();
                        this.regionalOptions = this.regionalOptions.filter((obj) => obj.companyAlternativeIdentifier === control.value);
                        this.serviceLocalOptions = [];
                        yield this.loadServiceLocalOptions();
                        this.loadAllServiceLocalsByCompany();
                        this.filtersForm.controls.regional.setValue("");
                        this.filtersForm.controls.serviceLocal.setValue("");
                        this.spinner.hide();
                    }
                }
                catch (error) {
                    this.spinner.hide();
                    Helper.handleError(error);
                }
            }
        }));
    }
    listenChangeRegional() {
        const control = this.filtersForm.controls.regional;
        control.valueChanges.subscribe(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!control.errors) {
                try {
                    this.spinner.show();
                    yield this.loadServiceLocalOptions();
                    if (control.value === "") {
                        this.loadAllServiceLocalsByCompany();
                    }
                    else {
                        this.serviceLocalOptions = this.serviceLocalOptions.filter((obj) => obj.regionalId === control.value);
                        if (!this.serviceLocalOptions.length) {
                            Alert.warning(Alert.getMessage().errors.serviceLocal.emptySearch);
                        }
                    }
                    this.spinner.hide();
                }
                catch (error) {
                    this.spinner.hide();
                    Helper.handleError(error);
                }
            }
        }));
    }
    listenChangeServiceLocal() {
        const control = this.filtersForm.controls.serviceLocal;
        control.valueChanges.subscribe(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!control.errors) {
                if (!_.isNull(control.value) && control.value !== "") {
                    this.filtersForm.controls.regional.setValue(this.serviceLocalOptions.find((obj) => obj.id === control.value)
                        .regionalId);
                }
            }
        }));
    }
    loadAllServiceLocalsByCompany() {
        const auxServiceLocal = [];
        this.filtersForm.controls.serviceLocal.setValue(null);
        this.regionalOptions.map((regional) => {
            // tslint:disable-next-line: max-line-length
            this.serviceLocalOptions
                .filter((obj) => obj.regionalId === regional.id)
                .map((serviceLocal) => auxServiceLocal.push(serviceLocal));
        });
        this.serviceLocalOptions = auxServiceLocal;
        this.filtersForm.controls.serviceLocal.setValue("");
        if (!this.serviceLocalOptions.length) {
            Alert.warning(Alert.getMessage().errors.serviceLocal.emptySearch);
        }
    }
    loadCompanyOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getCompanies();
                this.companyOptions =
                    this.authService.getUserLogged().type ===
                        globalConst.defaults.user.admin
                        ? data.status === undefined
                            ? data
                            : []
                        : this.authService.getUserLogged().companiesAssociate;
                if (!this.companyOptions.length) {
                    Alert.warning(Alert.getMessage().errors.company.emptySearch);
                }
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    loadRegionalOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getRegionals();
                this.regionalOptions =
                    this.authService.getUserLogged().type ===
                        globalConst.defaults.user.admin
                        ? data.status === undefined
                            ? data
                            : []
                        : this.authService.getUserLogged().regionalsAssociate;
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    loadServiceLocalOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getServiceLocals();
                this.serviceLocalOptions =
                    this.authService.getUserLogged().type ===
                        globalConst.defaults.user.admin
                        ? data.status === undefined
                            ? data
                            : []
                        : this.authService.getUserLogged().serviceLocalsAssociate;
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    loadAgents() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getAgents();
                this.agents =
                    data.status === undefined ? Agent.orderAgentByName(data) : [];
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    resetFilterForm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.filtersForm = new FormGroup({
                id: new FormControl(null),
                status: new FormControl({}),
                company: new FormControl(null),
                regional: new FormControl(null),
                serviceLocal: new FormControl(null),
                agent: new FormControl(null),
            });
            yield this.loadCompanyOptions();
            yield this.loadRegionalOptions();
            yield this.loadServiceLocalOptions();
            yield this.loadAgents();
        });
    }
    resetFilters() {
        this.filtersForm.reset();
        this.responseData = null;
        this.search();
    }
    handleFilter(pagination) {
        this.tablePagination = pagination;
        this.filter();
    }
    handleAction(event) {
        switch (event.action) {
            case "edit":
                this.router.navigate([event.routerLink], {
                    queryParams: event.queryParams,
                });
                break;
            default:
                break;
        }
    }
    search() {
        if (this.tablePagination)
            this.tablePagination.page = 1;
        this.filter();
    }
    filter() {
        this.spinner.show("osSpinner");
        this.subscription.add(this.serviceRequestService
            .listSchedules(Object.assign({}, this.filtersForm.value, this.tablePagination))
            .subscribe((res) => {
            this.spinner.hide("osSpinner");
            this.responseData = res;
        }, (err) => {
            this.spinner.hide("osSpinner");
            this.responseData = null;
            Alert.error(Alert.getMessage().errors.emptySearch);
        }));
    }
}
